import React,{useState} from "react";
import { Box,Typography,FormGroup,InputBase,Button, TextareaAutosize } from "@material-ui/core";
import axios from "axios";
import MessagePopup from "../MessagePopup";

const {UPDATE_B1_MAINPAGE} = require("../../api/MainPage/b1")

const B1Main = () => {
    const [openPopUp,setOpenPopUp] = useState(false);
    const [resp,setResp] = useState("");

    const [title,setTitle] = useState("");
    const [subTitle,setSubTitle] = useState("");
    const [videoLink,setVideoLink] = useState("");
    const [buttonName,setButtonName] = useState("");
    const [buttonLink,setButtonLink] = useState("");

    const handleUpdate = () => {
        if(title.length > 0 && subTitle.length > 0 && 
            videoLink.length > 0 && buttonName.length > 0 && buttonLink.length > 0){
            const new_Data = {
                title: title,
                subTitle: subTitle,
                videoLink: videoLink,
                buttonName: buttonName,
                buttonLink: buttonLink,
              }
              axios.put( UPDATE_B1_MAINPAGE,new_Data,{
                headers: {
                  Authorization: `Bearer ${window.localStorage.getItem("token")}`,
                },
              })
              .then(response => {
                setResp("Edited Successfully");
                setOpenPopUp(true);
                setTitle(""); setSubTitle(""); setVideoLink(""); setButtonLink(""); setButtonName("");
              })
              .catch((err) => {
                setResp("Something error occured");
                setOpenPopUp(true);
              });
        } else {
            setResp("Kindly add all the details");
            setOpenPopUp(true);
        }
    }

    return ( 
        <Box style={fullPage}>
            <Box  width={450}>
                    <Typography variant="h5" component="h2" fontWeight='650' style={{color: '#fff'}}>
                        Update B1 Page
                    </Typography>
                <Box sx={style}>
                    <FormGroup>
                        <TextareaAutosize
                            placeholder='Title'
                            minRows={2}
                            style={inputs}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        
                        <TextareaAutosize 
                            minRows={3}
                            placeholder='SubTitle' 
                            style={inputs}  
                            value={subTitle}
                            onChange={(e) => setSubTitle(e.target.value)}
                        />
                        
                        <InputBase 
                            placeholder='VideoLink' 
                            style={inputs}
                            value={videoLink}
                            onChange={(e) => setVideoLink(e.target.value)}
                        /> 
                        <InputBase 
                            placeholder='Button Name' 
                            style={inputs}
                            value={buttonName}
                            onChange={(e) => setButtonName(e.target.value)}
                        /> 
                        <InputBase 
                            placeholder='Button Link' 
                            style={inputs}
                            value={buttonLink}
                            onChange={(e) => setButtonLink(e.target.value)}
                        /> 
                    </FormGroup>
                    <Box display='flex' justifyContent='center' >
                        <Button style={btn} size='large' onClick={handleUpdate}>Update</Button>
                    </Box>
                </Box>
                <MessagePopup open={openPopUp} message={resp} handleAlertClose={() => setOpenPopUp(!openPopUp)}/>
            </Box>
    </Box>
);
}

const style = {
border: 'none',
boxShadow: 25,
textAlign: 'center',
color:'black',
boxSizing: 'content-box',
background: '#000',
p: 2,
borderRadius: 7,
};

const inputs ={
padding: 8,
marginTop: 7,
marginBottom: 7,
borderRadius: 5,
background: '#eee',
border: '1px solid #aaa',
}

const fullPage ={
width:'100%',
height:'90vh',
backgroundColor:'black',
display: 'flex',
justifyContent: 'center',
paddingTop: '2rem'
}

const btn={
color: '#000' ,
background: '#68F5D4' , 
marginTop: '10px'  , 
fontWeight: '650',
}
 
export default B1Main;